import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderSimplySharingJesus from "../../../../src/content/simplysharingjesus/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderSimplySharingJesus,
  React
};